import React, { Component } from 'react';
import 'Home/Components/EventDetails/eventdetails.css';
import config from 'config';
import HomeApiCall from 'HomeApiCall';
import ButtonLoader from 'Home/CommonResources/ButtonLoader/ButtonLoader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class EventDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES FOR FETCHING EVENT DETAILS
            fetchingEvent: false,
            eventList: {},
            academicYear: this.props.academicYear,
            department: this.props.department,
            eventSequenceIdArray:[]
        };
    }
    
    componentDidMount() {
        // METHOD CALLED TO GET EVENT DETAILS
        this.apiCallToGetEventDetails();
    }

    // API CALL METHOD TO GET EVENT DETAILS
    apiCallToGetEventDetails = async () => {
        this.setState({
            fetchingEvent: true
        });

        let requestData = {
            'acayr': this.state.academicYear,
            'sid': this.state.department,
            'pageIndex': 1,
            'limitPerPage': 5,
            'iid': config.institute_id,
            "filterStatus":"published"
        };

        let jsonResponse = await HomeApiCall.makeApiCall(
            'getPostEventList',
            requestData,
            '/api/event/postEvent.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetEventDetails();
            }, 1000);
        }else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
              
                this.setState({
                    eventList: apiResult,
                    eventSequenceIdArray:jsonResponse.APIResult.sortedIdArray,
                    fetchingEvent: false
                });
            }
        }
    }

    render() {
        return (
            <div className="eventData">
                <a href={`${config.RootUrl}/modules/event/#/`}>
                    <p style={{ fontSize: 15, fontWeight: 'bold', color: '#2979FF' }}>Events</p>
                </a>
                <div className="eventList scrollable">
                    {
                        this.state.fetchingEvent ? 
                        <ButtonLoader/>
                        :
                        this.state.eventSequenceIdArray.length>0 ? 

                        this.state.eventSequenceIdArray.map((eventId, index)=>{
                            let event = this.state.eventList[eventId]
                            return(
                                <div className="eventCard">
                                    <img src={event.BannerImage} className="BannerImage"/>
                                    <div className="EventTitle" >{event.eventTitle}</div>
                                    {
                                        event.postedByName && 
                                        <div className="PostedBy">Posted By {event.postedByName}</div>
                                    }
                                    <div className="StartDateReadable"><FontAwesomeIcon icon={['fas', 'calendar-alt']} style={{ marginRight:5 }} /> {event.StartDate}</div>
                                    <div className="EventLocation"><FontAwesomeIcon icon={['fas', 'map-marker-alt']} style={{ marginRight:5 }} /> {event.location}</div>
                                </div>
                            )
                        })
                        :
                            <p style={{ fontSize: 12, color: '#818181' }}>No event yet posted.</p>
                    }
                </div>
            </div>
        );
    }
}

export default EventDetails;